import { render, staticRenderFns } from "./EmployeeDniExpirationDateField.vue?vue&type=template&id=d8b6f6d6&"
import script from "./EmployeeDniExpirationDateField.vue?vue&type=script&lang=js&"
export * from "./EmployeeDniExpirationDateField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports